import React from 'react';
import { visuallyHidden } from '@mui/utils';
import TableSortLabel from '@mui/material/TableSortLabel';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import '../../Static/Master/firmtable.css';

const TableHeader = ({ headCells, order, orderBy, onRequestSort, numSelected, rowCount, onSelectAllClick }) => {
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableRow className='tbl-row'>
            {/* <TableCell padding="checkbox" className="table-header-checkbox">
                <Checkbox
                    indeterminate={numSelected > 0 && numSelected < rowCount}
                    checked={rowCount > 0 && numSelected === rowCount}
                    onChange={onSelectAllClick}
                />
            </TableCell> */}
            {headCells.map((headCell) => (
                <TableCell
                    key={headCell.id}
                    align="center"
                    sortDirection={orderBy === headCell.id ? order : false}
                    className="table-header-cell"
                    sx={{ p: 0.4, border: '1px solid #000' }}
                >
                    <TableSortLabel
                        active={orderBy === headCell.id}
                        direction={orderBy === headCell.id ? order : 'asc'}
                        onClick={createSortHandler(headCell.id)}
                        className='Label'
                    >
                        {headCell.label}
                        {orderBy === headCell.id ? (
                            <span className="visually-hidden">
                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </span>
                        ) : null}
                    </TableSortLabel>
                </TableCell>
            ))}
        </TableRow>
    );
};

export default React.memo(TableHeader);
